import { Directive } from '@angular/core';


@Directive({
  selector: 'mdl-layout-header[mdl-layout-header-transparent]',
  host: {
    '[class.mdl-layout__header--transparent]': 'true'
  }
})
export class MdlLayoutHeaderTransparentDirective {}



// WEBPACK FOOTER //
// ./src/lib/components/layout/mdl-layout-header-transparent.directive.ts